import React, { Component } from 'react';


import MatrixComponent from './../components/ChartMatrix/MatrixComponent';
import './../../selections/timeSelection/components/timeSelect/cliente.css';


//Actualizacion develop
class MatrixDB extends Component {        
        
    render() { 
        const {data, name, title} = this.props;
       return (
            <MatrixComponent 
                name={name}
                title={title}
                data={data}
                openDialog={this.props.openDialog}
                onClickGraphic={this.props.onClickGraphic}
                seeMore={this.props.seeMore}
                watchMenu={this.props.watchMenu}
            />
        );
    }
}

export default MatrixDB;